<template>
  <div>
    <nav>
      <div class="nav nav-tabs flex-row mb-4" id="nav-tab" role="tablist">
        <a
          class="nav-item nav-link active"
          id="nav-old-tab"
          data-toggle="tab"
          href="#nav-old"
          role="tab"
          aria-controls="nav-old"
          aria-selected="true"
          >Operators</a
        >
        <a
          class="nav-item nav-link"
          id="nav-new-tab"
          data-toggle="tab"
          href="#nav-new"
          role="tab"
          aria-controls="nav-new"
          aria-selected="false"
          >New operator</a
        >
        <a
          class="btn btn-info my-3 position-absolute right-0 mr-4 mb-3"
          :href="'/dashboard/package/rearrange'"
          target="_blank"
        >
          Re-arrange All Packages
        </a>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div class="tab-pane fade show active" id="nav-old" role="tabpanel" aria-labelledby="nav-old-tab">
        <app-operator></app-operator>
      </div>
      <div class="tab-pane fade" id="nav-new" role="tabpanel" aria-labelledby="nav-new-tab">
        <app-new-operator></app-new-operator>
      </div>
    </div>
  </div>
</template>

<script>
import Operator from "./Operator.vue";
import NewOperator from "./NewOperator.vue";

export default {
  name: "OperatorManagement",

  components: {
    appOperator: Operator,
    appNewOperator: NewOperator,
  },
};
</script>
